export type UrlParamCodec<T> = {
  encode: (value: T) => string
  decode: (raw: string) => T | null
}

function base64UrlEncode(value: string): string {
  return btoa(value).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

function base64UrlDecode(value: string): string {
  const padded = value.replace(/-/g, '+').replace(/_/g, '/').padEnd(
    value.length + ((4 - (value.length % 4)) % 4),
    '=',
  )
  return atob(padded)
}

export const stringCodec: UrlParamCodec<string> = {
  encode: (v) => v,
  decode: (raw) => raw || null,
}

export const numberCodec: UrlParamCodec<number> = {
  encode: (v) => String(v),
  decode: (raw) => {
    const n = Number(raw)
    return isNaN(n) ? null : n
  },
}

export function base64JsonCodec<T extends object>(): UrlParamCodec<T> {
  return {
    encode: (value) => {
      const stripped = Object.fromEntries(
        Object.entries(value).filter(([, v]) => {
          if (v === null || v === undefined) return false
          if (Array.isArray(v) && v.length === 0) return false
          if (typeof v === 'string' && v.trim() === '') return false
          return true
        }),
      )
      return base64UrlEncode(JSON.stringify(stripped))
    },
    decode: (raw) => {
      try {
        return JSON.parse(base64UrlDecode(raw)) as T
      } catch {
        return null
      }
    },
  }
}
